export default "__VITE_ASSET__gchGlPZa__"